export default {"src":"/_next/static/media/PivotsIcon.ead5142b.svg","height":78,"width":78};